<template>
  <section class="mt-48">
    <h2 class="text-h3 mb-16">Stand out to parents</h2>
    <div class="grid grid-cols-1 sm:grid-cols-2 sm:gap-16 gap-32">
      <ImageLinkCard
        class="col-span-1"
        title="Add a background check"
        content="Make a great first impression and build trust with families"
        :linkValue="hasActiveBackgroundCheck ? 'Manage Background Checks' : 'Run a check'"
        linkURL="/account/providers/background-checks"
        :useFullPageNavigation="true"
      >
        <template #rightSide>
          <BackgroundChecksIllustration class="w-full" :width="64" :height="64" />
        </template>
      </ImageLinkCard>
      <ImageLinkCard
        class="col-span-1"
        title="Request a review"
        content="Boost your profile: pick a family, we'll request a review for you"
        linkValue="Request review"
        @click="toggleReviewModal(true)"
      >
        <template #rightSide>
          <RequestReviewsIllustration class="w-full" :width="64" :height="64" />
        </template>
      </ImageLinkCard>
      <ImageLinkCard
        class="col-span-1"
        title="Get noticed as a Featured Sitter"
        content="Get free background checks and preferred ranking in search"
        :linkValue="hasPremiumSubscription ? 'Manage Subscription' : 'Upgrade your profile'"
        :linkURL="hasPremiumSubscription ? '/account/settings' : '/account/providers/featured_sitter/new'"
        :useFullPageNavigation="true"
      >
        <template #rightSide>
          <SitterTeamIllustration class="w-full" :width="64" :height="64" />
        </template>
      </ImageLinkCard>
      <ImageLinkCard
        class="col-span-1"
        title="Connect with other sitters"
        content="Our community loves answering questions and sharing ideas"
        linkValue="Join now"
        linkURL="https://www.facebook.com/groups/sittercommunity/"
      >
        <template #rightSide>
          <SitterResponseIllustration class="w-full" :width="64" :height="64" />
        </template>
      </ImageLinkCard>
      <BHPartnersImageLinkCardWrapper :sitterPartnerKey="ProTrainings_CPR_Sitter_key">
        <ImageLinkCard
          class="col-span-1 sm:col-span-2"
          :title="ProTrainings_CPR_Sitter.headerText"
          :content="ProTrainings_CPR_Sitter.bodyText"
          :linkValue="ProTrainings_CPR_Sitter.ctaText"
          :linkURL="ProTrainings_CPR_Sitter.ctaLink"
          :openInNewTab="true"
        >
          <template #rightSide>
            <ProTrainingsIcon class="w-full" />
          </template>
        </ImageLinkCard>
      </BHPartnersImageLinkCardWrapper>
    </div>
    <p class="text-caption text-grey-text-subdued mt-8">Sittercity may receive a small commission for your purchase</p>
    <RequestReviewPopup
      :value="showReviewModal"
      :sitterId="sitterId"
      :sitterName="sitterName"
      @close="toggleReviewModal(false)"
    />
  </section>
</template>

<script lang="ts">
import ImageLinkCard from '@/components/image_link_card/ImageLinkCard.vue';
import BackgroundChecksIllustration from '@/graphics/illustrations/BackgroundChecksIllustration.vue';
import RequestReviewsIllustration from '@/graphics/illustrations/RequestReviewsIllustration.vue';
import SitterTeamIllustration from '@/graphics/illustrations/SitterTeamIllustration.vue';
import SitterResponseIllustration from '@/graphics/illustrations/SitterResponsesIllustration.vue';
import BHPartnersImageLinkCardWrapper from '@/components/bh_partners/BHPartnersImageLinkCardWrapper.vue';
import ProTrainingsIcon from '@/icons/ProTrainingsIcon.vue';
import { PROTRAININGS_CPR_SITTER_DATA, PROTRAININGS_CPR_SITTER_KEY } from '@/lib/partners.data';
import { SITTER_PROFILE_QUERY } from '@/graphql/adventures/queries';
import RequestReviewPopup from './RequestReviewPopup.vue';

export default {
  name: 'ResourceCards',
  components: {
    ImageLinkCard,
    BackgroundChecksIllustration,
    RequestReviewsIllustration,
    SitterTeamIllustration,
    SitterResponseIllustration,
    BHPartnersImageLinkCardWrapper,
    ProTrainingsIcon,
    RequestReviewPopup,
  },
  props: {
    sitterId: {
      type: String,
      required: true,
    },
    sitterName: {
      type: String,
      required: true,
    },
    initialShowReviewModal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      sitterProfile: {},
      ProTrainings_CPR_Sitter: PROTRAININGS_CPR_SITTER_DATA,
      ProTrainings_CPR_Sitter_key: PROTRAININGS_CPR_SITTER_KEY,
      showReviewModal: this.initialShowReviewModal,
    };
  },
  computed: {
    hasActiveBackgroundCheck(): boolean {
      return this.sitterProfile.hasActiveBackgroundCheck || false;
    },
    hasPremiumSubscription(): boolean {
      return this.sitterProfile.hasPremiumSubscription || false;
    },
  },
  methods: {
    toggleReviewModal(val) {
      this.showReviewModal = val;
    },
  },
  apollo: {
    sitterProfile: {
      query: SITTER_PROFILE_QUERY,
    },
  },
};
</script>
<style>
.full-width-card .icon-container {
  max-width: 10rem;
  width: 100%;
  margin-bottom: 0.5rem;
}
@media only screen and (max-width: 768px) {
  .full-width-card .card {
    display: flex;
    flex-direction: column-reverse;
    align-items: flex-start;
  }
}
#ot-sdk-btn-floating.ot-floating-button {
  @media only screen and (max-width: 768px) {
    z-index: 51 !important;
  }
}
</style>
